// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-red {
    background-color: red;
}

.bg-blue {
    background-color: blue;
}

.bg-black {
    background-color: black;
}

.width25 {
    width: 25%;
}

.width33 {
    width: 33%;
}

.width50 {
    width: 50%;
}

.width90 {
    width: 90%;
}

.width100 {
    width: 100%;
}

.width100px {
    width: 100px;
}

.width120px {
    width: 120px;
}

.width150px {
    width: 150px;
}

.mx-width150px {
    max-width: 150px !important;
}

.display-grid {
    display: grid;
}

.justify-content-flex-end {
    display: flex;
    justify-content: flex-end;
}

.flex-wrap {
    display: flex;
    flex-wrap: wrap;
}

.justify-content-flex-center {
    display: flex;
    justify-content: center;
}

.align-items-flex-end {
    display: flex;
    align-items: flex-end;
}


.flex-direction-row-reverse {
    display: flex;
    flex-direction: row-reverse;
}

.flex-direction-column {
    display: flex;
    flex-direction: column;
}

.flex-direction-column-reverse {
    display: flex;
    flex-direction: column-reverse;
}

.flex-content-space-around {
    display: flex;
    justify-content: space-around;
}

.flex-content-align-items-stretch {
    display: flex !important;
    align-items: stretch;
}

.flex-content-space-between {
    display: flex;
    justify-content: space-between;
}

.flex-align-items-center {
    display: flex;
    align-items: center;
}

.flex-align-items-center-space-evenly {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.flex-align-items-center-space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.floatRight {
    float: right;
}

.floatLeft {
    float: left;
}

.imgSize8 {
    height: 8px;
    width: 8px;
}

.imgSize12 {
    height: 12px;
    width: 12px;
}

.imgSize14 {
    height: 14px;
    width: 14px;
}

.imgSize20 {
    height: 20px;
    width: 20px;
}

.imgSize25 {
    height: 25px;
    width: 25px;
}

.imgSize30 {
    height: 30px;
    width: 30px;
}

.successBtn {
    border-radius: 20px !important;
    background-color: #91C24C !important;
    color: #fff !important;
    font-weight: 700 !important;
}

.closeBtn {
    border-radius: 20px !important;
    background-color: #DB1E36 !important;
    color: #fff !important;
    font-weight: 700 !important;
    margin-right: 10px !important;
}

.align-center {
    text-align: center;
}

.cursor-pointer {
    cursor: pointer;
}


.text-underline {
    text-decoration-line: underline;
}

.coming-soon {
    text-align: center;
    color: #000;
    font-size: 24px;
    padding: 20%;
}

.loaderWrapper {
    max-width: 500px;
    margin: auto;
    padding-top: 30%;
}

.disable {
    pointer-events: none;
}

.emptyBtn {
    background: unset !important;
    color: black;
    border: unset;
    padding: unset;


    &:focus {
        color: black;
        background: transparent;
        outline: none;
        box-shadow: none;
    }

}

.btn-primary :hover {
    background-color: #007bff !important;
    border-radius: 6px;
}

.disableBtn {
    background-color: #e9e9e9 !important;
    color: #626262 !important;
    cursor: unset !important;
    pointer-events: none;
}


.loaderWrapperRightPanel {
    margin-top: 100%;
    margin-left: 40%;
}

label {
    margin-top: 8px;
    font-size: 20px;
    color: #384A9C;
    font-weight: 700;
}

.successMsg {
    color: green;
}

.errorMsg {
    color: red;
}

.css-ittuaa-MuiInputAdornment-root {
    margin-right: -10px !important;
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/global.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,cAAc;;;IAGd;QACI,YAAY;QACZ,uBAAuB;QACvB,aAAa;QACb,gBAAgB;IACpB;;AAEJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;AACxB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".bg-red {\n    background-color: red;\n}\n\n.bg-blue {\n    background-color: blue;\n}\n\n.bg-black {\n    background-color: black;\n}\n\n.width25 {\n    width: 25%;\n}\n\n.width33 {\n    width: 33%;\n}\n\n.width50 {\n    width: 50%;\n}\n\n.width90 {\n    width: 90%;\n}\n\n.width100 {\n    width: 100%;\n}\n\n.width100px {\n    width: 100px;\n}\n\n.width120px {\n    width: 120px;\n}\n\n.width150px {\n    width: 150px;\n}\n\n.mx-width150px {\n    max-width: 150px !important;\n}\n\n.display-grid {\n    display: grid;\n}\n\n.justify-content-flex-end {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.flex-wrap {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.justify-content-flex-center {\n    display: flex;\n    justify-content: center;\n}\n\n.align-items-flex-end {\n    display: flex;\n    align-items: flex-end;\n}\n\n\n.flex-direction-row-reverse {\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n.flex-direction-column {\n    display: flex;\n    flex-direction: column;\n}\n\n.flex-direction-column-reverse {\n    display: flex;\n    flex-direction: column-reverse;\n}\n\n.flex-content-space-around {\n    display: flex;\n    justify-content: space-around;\n}\n\n.flex-content-align-items-stretch {\n    display: flex !important;\n    align-items: stretch;\n}\n\n.flex-content-space-between {\n    display: flex;\n    justify-content: space-between;\n}\n\n.flex-align-items-center {\n    display: flex;\n    align-items: center;\n}\n\n.flex-align-items-center-space-evenly {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n.flex-align-items-center-space-between {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.floatRight {\n    float: right;\n}\n\n.floatLeft {\n    float: left;\n}\n\n.imgSize8 {\n    height: 8px;\n    width: 8px;\n}\n\n.imgSize12 {\n    height: 12px;\n    width: 12px;\n}\n\n.imgSize14 {\n    height: 14px;\n    width: 14px;\n}\n\n.imgSize20 {\n    height: 20px;\n    width: 20px;\n}\n\n.imgSize25 {\n    height: 25px;\n    width: 25px;\n}\n\n.imgSize30 {\n    height: 30px;\n    width: 30px;\n}\n\n.successBtn {\n    border-radius: 20px !important;\n    background-color: #91C24C !important;\n    color: #fff !important;\n    font-weight: 700 !important;\n}\n\n.closeBtn {\n    border-radius: 20px !important;\n    background-color: #DB1E36 !important;\n    color: #fff !important;\n    font-weight: 700 !important;\n    margin-right: 10px !important;\n}\n\n.align-center {\n    text-align: center;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n\n.text-underline {\n    text-decoration-line: underline;\n}\n\n.coming-soon {\n    text-align: center;\n    color: #000;\n    font-size: 24px;\n    padding: 20%;\n}\n\n.loaderWrapper {\n    max-width: 500px;\n    margin: auto;\n    padding-top: 30%;\n}\n\n.disable {\n    pointer-events: none;\n}\n\n.emptyBtn {\n    background: unset !important;\n    color: black;\n    border: unset;\n    padding: unset;\n\n\n    &:focus {\n        color: black;\n        background: transparent;\n        outline: none;\n        box-shadow: none;\n    }\n\n}\n\n.btn-primary :hover {\n    background-color: #007bff !important;\n    border-radius: 6px;\n}\n\n.disableBtn {\n    background-color: #e9e9e9 !important;\n    color: #626262 !important;\n    cursor: unset !important;\n    pointer-events: none;\n}\n\n\n.loaderWrapperRightPanel {\n    margin-top: 100%;\n    margin-left: 40%;\n}\n\nlabel {\n    margin-top: 8px;\n    font-size: 20px;\n    color: #384A9C;\n    font-weight: 700;\n}\n\n.successMsg {\n    color: green;\n}\n\n.errorMsg {\n    color: red;\n}\n\n.css-ittuaa-MuiInputAdornment-root {\n    margin-right: -10px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
